import React from "react";
import { Image, Row, Col } from "react-bootstrap";

//STYLES
import * as OrderDetailsItemStyles from "../../styles/order/orderDetailsItem";

function OrderDetailsItem(props) {
    return (
        <div>
            <div style={OrderDetailsItemStyles.body}>
                <Row>
                    <Col md="auto">
                        <Image
                            src={`/content/3dPrintingShop/products/${props.item.itemDetails.uuid.toString()}/${props.item.itemDetails.mainImage}`}
                            style={OrderDetailsItemStyles.image}
                        />
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <strong>Name:</strong> {props.item.itemDetails.title} <br />
                                <strong>Quantity:</strong> {props.item.quantity} <br /> <br />
                                {props.item.customItem == "true" && (
                                    <div>
                                        <strong style={OrderDetailsItemStyles.customTitle}>Customisation</strong>
                                        {props.item.itemDetails.customItems.map((field, index) => {
                                            if (field.type == "text" || field.type == "dColour") {
                                                return (
                                                    <div key={index}>
                                                        {field.fieldName}: {field.fieldValue}
                                                    </div>
                                                );
                                            }
                                        })}
                                        {props.item.itemDetails.customColours && (
                                            <div>
                                                <br />
                                                <strong>Colours:</strong>
                                                {props.item.itemDetails.customItems.map((field, index) => {
                                                    if (field.type == "colour") {
                                                        return (
                                                            <div key={index}>
                                                                {field.fieldName}: {field.fieldValue}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col style={OrderDetailsItemStyles.columnRight}>
                                <strong>Price Per Item:</strong> £{(props.item.fullPriceWhenOrdered / 100).toFixed(2)} <br />
                                <strong>Total:</strong> £{((props.item.fullPriceWhenOrdered * props.item.quantity) / 100).toFixed(2)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <br />
        </div>
    );
}

export default OrderDetailsItem;
